const zeroWidthSpace = '\u200b';
const transformText = function(inputString) {
  return inputString.split(' ').join(`_${zeroWidthSpace}`).toUpperCase();
}

export default transformText;